import Keycloak from "keycloak-js"

let keycloak = null

export function getKeycloak() {
  if (!keycloak) {
    keycloak = new Keycloak({
      url: process.env.REACT_APP_KC_URL,        
      realm: process.env.REACT_APP_KC_REALM,    // lab-platform
      clientId: process.env.REACT_APP_KC_CLIENT_ID // web-public-client
    })
  }
  return keycloak
}
